import { GapDialogProps } from 'reusable/gap-dialog/GapDialog'
import { messageActions } from './message-actions'

export async function messageInfo(children: GapDialogProps['children'], title = 'Info', options?: GapDialogProps) {
    if (title === undefined || title === null) {
        title = 'Info'
    }

    return messageActions({
        title: title,
        children: children,
        primary: {
            name: 'Ok'
        },
        ...options,
    })
}
